module.exports = __webpack_public_path__ + "res/img_back_rtl.fea5c3f1dc4174337996bf85c71617cd.png";